/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocationTypeWithRelations } from '../../models/location-type-with-relations';

export interface AdminGetList$Params {
}

export function adminGetList(http: HttpClient, rootUrl: string, params?: AdminGetList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LocationTypeWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, adminGetList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LocationTypeWithRelations>>;
    })
  );
}

adminGetList.PATH = '/admin/location-types';
